<template>
  <agent-default>
    <pa-plan-select-page channel="agent" />
  </agent-default>
</template>

<script>
import AgentDefault from '@/components/layout/AgentDefault';
import PaPlanSelectPage from '@/components/pa/PaPlanSelectPage';

export default {
  name: 'AgentPaPlanSelect',
  components: { AgentDefault, PaPlanSelectPage },
  metaInfo: { title: 'Students PA — Select Cover' },
};
</script>
